import React, { useRef, useState, useEffect, memo } from 'react';
import classNames from 'classnames';
import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import './styles.scss';

export const FixedDropdownMenu = memo((props) => {
  const { children, trigger, horizontal, wrapperClass, menuWrapperClass, allowMenuOpen, triggerClass, buttonStyle, disabled } = props;

  const referenceRef = useRef(null);
  const buttonRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState(null);

  const [isActive, setIsActive] = useDetectOutsideClick(referenceRef, false, allowMenuOpen);

  const handleDropdownClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const rect = buttonRef.current.getBoundingClientRect();
    setMenuStyle({ position: 'fixed', top: rect.bottom, left: rect.left });
    setIsActive((pre) => !pre);
  };

  useEffect(() => {
    if (!isActive) return;
    const close = () => setIsActive(false);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [isActive, setIsActive]);

  return (
    <div ref={referenceRef} className={classNames('dropdown-menu--wrapper', wrapperClass)}>
      <button
        ref={buttonRef}
        type="button"
        className={classNames('menu-button', triggerClass)}
        style={buttonStyle}
        onClick={handleDropdownClick}
        disabled={disabled}
      >
        {trigger}
      </button>
      {isActive && (
        <div className={classNames('menu', menuWrapperClass, { 'flex-column': horizontal })} style={menuStyle}>
          {children}
        </div>
      )}
    </div>
  );
});
